import React from "react";
import Stars from "./stars";
import { Link } from "react-router-dom";

const WorstStores = ({data}) => {
  return (
    <section className="card rounded-4">
      <div className="card-body">
        <h6 className="mb-4"> المتاجر ذات الأداء المنخفض</h6>
       {data.map((store)=>(
<div className="worst-store-card w-100" key={store.id}>
            <div>
                  <div className="d-flex align-items-center gap-2">
            <h4>{store.name} </h4>

            <div className="rating-badge">تقييم منخفض ({store.rating})</div>
          </div>
          <Stars rating={store.rating}/>

            </div>
        
             <div className="fs-5">الطلبات: {store.order_count}</div>
             <Link className="btn  btn-white" to={`${process.env.PUBLIC_URL}/store/${store.id}`}>عرض المتاجر</Link>
        </div>
       )) }
      </div>
    </section>
  );
};

export default WorstStores;
